import { v4 as uuidv4 } from "uuid";

const LS_RID = "_r_id";
export const getSetRid = () => {
    let rid = localStorage.getItem(LS_RID);
    if (!rid) {
        rid = uuidv4();
        localStorage.setItem(LS_RID, rid);
    }
    return rid;
};
